import script from "./RequestPasswordReset.vue?vue&type=script&setup=true&lang=js"
export * from "./RequestPasswordReset.vue?vue&type=script&setup=true&lang=js"

import "./RequestPasswordReset.vue?vue&type=style&index=0&id=702432ae&scoped=true&lang=css"
import "./RequestPasswordReset.vue?vue&type=style&index=1&id=702432ae&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-702432ae"]])

export default __exports__